<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newUser()"
                aria-label="New User"
                *appIsGranted="['Workers', 'CREATE']"
        >
            {{'New'|translate}}
        </button>
    </div>

    <div class="nav material2">
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/employee-schedule'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">access_alarm</mat-icon>
                <span>{{'Employee schedule'|translate}}</span>
            </a>
        </div>
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
